import { render } from "./PolicyDocuments.vue?vue&type=template&id=6fed5c47"
import script from "./PolicyDocuments.vue?vue&type=script&lang=js"
export * from "./PolicyDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__